import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { CreateNoteRequest, UpdateNoteRequest, DeleteNoteRequest } from '../types';
import { Note } from '../../types';

export abstract class NotesListBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getNotes(): Promise<Note[]>;

  public abstract createNote(request: CreateNoteRequest): Promise<void>;

  public abstract updateNote(request: UpdateNoteRequest): Promise<void>;

  public abstract deleteNote(request: DeleteNoteRequest): Promise<void>;

  protected buildDataForView(notes: any[]): Note[] {
    return notes.map((note: any): Note => ({
      _id: note._id,
      text: note.text,
      resourceId: note[this.getResourceIdApiField()],
      user: note.user,
      created: note.created,
      lastUpdated: note.lastUpdated,
    }));
  }

  protected getResourceIdApiField(): string {
    return this.dependencies.api.resourceIdField ?? 'resourceId';
  }
}
